<template>
    <g fill="none" fill-rule="evenodd">
        <g>
            <g transform="translate(-39 -135) translate(39 135)">
                <path fill="#95A6B8" d="M0 7c0-3.866 3.129-7 6.991-7h8.018C18.869 0 22 3.142 22 7c0 3.866-3.129 7-6.991 7H6.99C3.131 14 0 10.858 0 7z"/>
                <circle cx="7" cy="7" r="5" fill="#FFF"/>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: 'offToggleIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 22 14');
    }
};
</script>
